import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { baseUrl } from "../../config/baseUrl";
import OwnerCouponForm from "./OwnerCouponForm";

const initialFormData = {
  code: "",
  discountType: "percentage",
  discountValue: "",
  validFrom: "",
  validTill: "",
  isActive: "true",
};

export default function OwnerCouponAdd() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialFormData);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: name === "code" ? value.toUpperCase() : value,
    }));
  };

  const validateForm = () => {
    if (!formData.code.trim()) {
      toast.error("Coupon code is required");
      return false;
    }

    if (!formData.discountValue || Number(formData.discountValue) <= 0) {
      toast.error("Discount value must be greater than 0");
      return false;
    }

    if (
      formData.discountType === "percentage" &&
      Number(formData.discountValue) > 100
    ) {
      toast.error("Percentage discount cannot exceed 100");
      return false;
    }

    if (!formData.validFrom || !formData.validTill) {
      toast.error("Please select valid dates");
      return false;
    }

    if (new Date(formData.validTill) <= new Date(formData.validFrom)) {
      toast.error("Valid till must be after valid from");
      return false;
    }

    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        `${baseUrl}/owner/coupons/add`,
        {
          code: formData.code.trim(),
          discountType: formData.discountType,
          discountValue: Number(formData.discountValue),
          validFrom: formData.validFrom,
          validTill: formData.validTill,
          isActive: formData.isActive === "true",
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.status) {
        toast.success("Coupon created successfully");
        navigate("/coupons");
      }
    } catch (error) {
      console.error("Create coupon error:", error);
      toast.error(error.response?.data?.message || "Failed to create coupon");
    } finally {
      setLoading(false);
    }
  };

  return (
    <OwnerCouponForm
      title="Create Coupon"
      formData={formData}
      loading={loading}
      onChange={handleChange}
      onSubmit={handleSubmit}
      submitLabel="Save Coupon"
    />
  );
}
